jQuery(document).foundation();
AOS.init();

( function( $ ) {
	var twms = {
		cache: {},
		handlers: {},
		init: function() {
			this.cacheElements();
			this.bindEvents();
		},
		cacheElements: function() {
			this.cache = {
				$window: $( window ),
				$document: $( document )
			};
		},
		bindEvents: function() {
			var self = this;
			self.cache.$document.ready( function() {
				self.initSlider();
			});
		},
		initSlider: function() {
			var slider = $( '.events-carousel' );
			slider.owlCarousel({
				loop: false,
				items: 1,
				margin: 0,
				nav: true,
				dots: false,
                navText: [
					'<span class="icon"></span>',
					'<span class="icon"></span>'
				],
                responsive:{
                    600:{
                        items:2
                    },
                    1000:{
                        items:4
                    }
                }
			});
		},
	};
	twms.init( twms );
}( jQuery ) );

jQuery('.box-contact-countries .item-country-header').on( 'click', function(e){
    e.preventDefault();
    jQuery(this).toggleClass('active');
    jQuery(this).next().stop(true, false).slideToggle();
})


